import { api } from 'pages/APIs';
import AbstractApiService from 'src/services/abstractApiService';

export default class FormatDateService extends AbstractApiService {
  public constructor() {
    super({});
  }

  format(value: string, locale: string, pattern: string): Promise<any> {
    const formData = new FormData();
    formData.append('value', value);
    formData.append('doc_locale', locale);
    formData.append('date_pattern', pattern);
    return super.post(api.get_formatted_date, formData);
  }
}
